module.exports = __webpack_public_path__ + "img/light-mud-decal-12.16de03e4.png";